import React, { useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';

import {Box, Typography} from "@mui/material";
import { makeStyles } from "tss-react/mui";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";


import mouth_closed_img from "./img/mouth_closed.png";

import face_centered_img from "./img/face_centered.png";
import face_centered_double_img from "./img/face_centered_double_crosshair.svg";

import no_glasses_img from "./img/no_glasses.png";
import scan_level_img from "./img/scan_level.png";
import lighting_img from "./img/lighting.png";

import { SHOW_DOUBLE_CROSSHAIR } from "../../components/mugshot/FaceMeasurer/MugShotConfig";

import BackNextNavigation from "./BackNextNavigation";

const ScanInstructionsMouthClosed = ( { handleNext, handlePrevious = undefined, instruction, showStartScanButton = false } ) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ScanInstructions");

    const mouthHeader = t("mouthHeader");
    const mouthInstruction = t("mouthInstruction");
    const glassesHeader = t("glassesHeader");
    const glassesInstruction = t("glassesInstruction");
    const centeredHeader = t("centeredHeader");
    const centeredInstruction = t("centeredInstruction");
    const levelHeader = t("levelHeader");
    const levelInstruction= t("levelInstruction");
    const lightingHeader = t("lightingHeader");
    const lightingInstruction = t("lightingInstruction");

    const { t:tPrepPage } = useTranslation("pages.MaskSelectorTool.SizingScanPrepPage");
    const readyToScanButton = tPrepPage("readyToScanButton");

    const {classes} = MaskSelectorToolStyles();

    const ScanInstructionsStyles = makeStyles()(() => ({
        header: {
            fontSize: 24,
            fontWeight: 600
        }
    }));

    const {classes: scanInstructionsClasses} = ScanInstructionsStyles();

    const headingRef = useRef(null);

    useEffect(() => {
        if(headingRef?.current) {
            headingRef.current.focus();
        }
    });

    let image = undefined;
    let headerText = "";
    let instructionText = "";

    switch(instruction) {
        case "glasses":
            image = no_glasses_img;
            headerText = glassesHeader;
            instructionText = glassesInstruction
            break;

        case "centered":
            image = SHOW_DOUBLE_CROSSHAIR ? face_centered_double_img : face_centered_img;
            headerText = centeredHeader;
            instructionText = centeredInstruction
            break;

        case "level":
            image = scan_level_img;
            headerText = levelHeader;
            instructionText = levelInstruction;
            break;

        case "lighting":
            image = lighting_img;
            headerText = lightingHeader;
            instructionText = lightingInstruction;
            break;

        case "mouth":
        default:
            image = mouth_closed_img;
            headerText = mouthHeader;
            instructionText = mouthInstruction;
            break;
    }

    // For debugging in Safari.
    const handleNextInternal = () => {
        if (console.takeHeapSnapshot ) {
            console.takeHeapSnapshot("Starting Scan");
        }
        handleNext();
    }

    const buttonNavigationHeight = "70px";

    return (
        <>
            <Box sx={{height: "100%"}} className={ `${classes.mainBox} ${classes.instructionMainBox}` }>

                <Box>
                    <Box className={ `${classes.instructionBox} ${classes.centeredBox}` }>
                        <img alt="" src={image} />
                    </Box>

                    <Box paddingY="24px">
                        <Box className = {classes.centeredBox}>
                            <Typography className={`${scanInstructionsClasses.header} ${classes.noOutline}`} tabIndex="0" aria-label={headerText} ref={headingRef}>{headerText}</Typography>
                        </Box>
                        <Box className = {classes.centeredBox} minHeight="120px">
                            <Typography className={`${classes.instruction} ${classes.noOutline}`} tabIndex="0" aria-label={instructionText}>{instructionText}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            { showStartScanButton && (
                <Box mt={1} className={`${classes.buttonBox}`}>
                    <BackNextNavigation handleNext={handleNextInternal}
                                        nextLabel={readyToScanButton}
                                        handlePrevious={handlePrevious}
                                        />
                </Box>

)}

            { !showStartScanButton && (
                <Box className={`${classes.buttonBox}`}>
                    <BackNextNavigation handleNext={handleNext} handlePrevious={handlePrevious} />
                </Box>
            )}
        </>
    )
}

export default ScanInstructionsMouthClosed;
